export default "a41e8086d3c28224.png"